var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},_vm._l((_vm.text),function(row){return _c('div',{key:row,staticClass:"row"},_vm._l((row),function(letter){return _c('div',{key:letter,staticClass:"letter"},[_vm._v(" "+_vm._s(letter)+" ")])}),0)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }